<template>
  <v-container fluid>
    <ModalLicenca
      :modalLicenca="modalLicenca"
      :editLicenca="editLicencaObj"
      @close="closeModalLicenca"
    />
    <Grid
      title="Licenças"
      :headers="headers"
      :items="licencas"
      @novo="modalLicenca = true"
      @edit="editLicenca"
      @destroy="destroyLicenca"
      @atualiza="getLicencas"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Grid from '@/components/shared/Grid';
import ModalLicenca from '@/components/licenca/ModalLicenca';

export default {
  name: 'Licencas',
  data: () => ({
    modalLicenca: false,
    editLicencaObj: null,
    headers: [
      {
        text: 'Título',
        align: 'start',
        value: 'titulo',
      },
      { text: 'Status', value: 'status' },
      { text: 'Conexões Simultâneas', value: 'conexoes_simultaneas' },
      { text: 'Aplicativo', value: 'aplicativo.app_key.descricao' },
      { text: 'Data Expiração', value: 'data_expiracao' },
      // { text: 'Criada em', value: 'createdAt' },
      { text: 'Atualizada em', value: 'updatedAt' },
      { text: 'Ações', value: 'actions', sortable: false },
    ],
  }),
  components: {
    Grid,
    ModalLicenca
  },
  computed: {
    ...mapGetters(['licencas'])
  },
  methods: {
    ...mapActions(['fetchLicencas', 'deleteLicenca']),
    closeModalLicenca() {
      this.editLicencaObj = null;
      this.modalLicenca = false;
    },
    getLicencas() {
      this.fetchLicencas({ limit: 999 });
    },
    editLicenca(licenca) {
      this.editLicencaObj = { ...licenca };
      this.modalLicenca = true;
    },
    destroyLicenca(licenca) {
      if (confirm(`Tem certeza que deseja excluir a licenca: ${licenca.titulo}?`)) {
        this.deleteLicenca(licenca._id);
      }
    }
  },
  created() {
    this.getLicencas();
  }
}
</script>

<style>

</style>